import React from "react";
import { Outlet, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

// Bug 1736 — sidemenu.js already grays out "Jewelery Report"/"Global Jewelry" menu items
// per-dealer via headerMenuReducer.reportPermisstion, but that flag was never enforced on
// the routes themselves, so a direct URL (e.g. /jewelryChartReport) bypassed it entirely.
// This mirrors the same reportPermisstion flag at the route level.
const ReportPermissionGuard = ({ permission }) => {
  const headerDetials = useSelector((state) => state.headerMenuReducer);
  const isEntitled = headerDetials?.reportPermisstion?.[0]?.[permission] === true;

  return isEntitled ? <Outlet /> : <Navigate to="/notAccess" replace />;
};

export default ReportPermissionGuard;
